import {
  CreateUnauthorizedOrganizationPayloadType,
  createUnauthorizedOrganizationApi,
} from '@/api/v1/organization/unauthorized/createUnauthorizedOrganizationApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const createUnauthorizedOrganization = async (payload: CreateUnauthorizedOrganizationPayloadType) => {
  try {
    const response = await createUnauthorizedOrganizationApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
